import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { CalendarMonth, Assignment, ReceiptLong } from "@mui/icons-material";
import { typeTokens } from "../../../theme/tokens";

/**
 * The three components the product is organised around, per docs/FEATURES.md.
 */
const features = [
  {
    icon: CalendarMonth,
    eyebrow: "Calendar",
    title: "Holds and challenges",
    description:
      "Track 1st, 2nd, and 3rd holds on every date. Drag to hold a multi-night run. Timed challenges force a decision rather than letting a date sit.",
  },
  {
    icon: Assignment,
    eyebrow: "Advancement",
    title: "Multi-act bills",
    description:
      "Tech riders, standard riders, stage plots, and input lists for every act on the bill, with production and hospitality sheets ready to print.",
  },
  {
    icon: ReceiptLong,
    eyebrow: "Settlement",
    title: "Industry deal structures",
    description:
      "Guarantee, door, versus, split point and more. House nut, split point, and overage calculated as you go, exported as a settlement sheet.",
  },
];

export default function FeatureHighlight(): React.ReactElement {
  return (
    <Box sx={{ py: { xs: 4, md: 6 } }}>
      <Box
        sx={{
          display: "grid",
          gap: 3,
          gridTemplateColumns: {
            xs: "1fr",
            md: "repeat(3, 1fr)",
          },
        }}
      >
        {features.map(({ icon: Icon, eyebrow, title, description }) => (
          <Paper key={title} elevation={0} sx={{ p: 3, height: "100%" }}>
            <Stack spacing={1.5} alignItems="flex-start">
              <Icon sx={{ color: "text.primary" }} />
              <Typography
                sx={{ ...typeTokens.microLabel, color: "text.secondary" }}
              >
                {eyebrow}
              </Typography>
              <Typography variant="h6" fontWeight={700}>
                {title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {description}
              </Typography>
            </Stack>
          </Paper>
        ))}
      </Box>
    </Box>
  );
}
